module.exports = __webpack_public_path__ + "img/sy.02456c44.svg";